import React from 'react'
import { connect } from 'react-redux'
import { actualizarDropdownEtiquetas, submitFiltrosParaEmbarque } from '../actions/filtroCerealCerealVariedadYEtiquetaActions'
import { FiltroCerealCerealVariedadYEtiquetaView } from '../component/FiltroCerealCerealVariedadYEtiquetaView'

class FiltroCerealCerealVariedadYEtiqueta extends React.Component {
  componentDidUpdate (prevProps) {
    console.log('componentDidUpdate', this.props.cereal, this.props.cerealVariedad, prevProps.cereal, prevProps.cerealVariedad)
    if (this.props.cereal !== undefined && this.props.cerealVariedad !== undefined && (this.props.cereal !== prevProps.cereal || this.props.cerealVariedad !== prevProps.cerealVariedad)) {
      console.log('despues de entrar', this.props.cereal, this.props.cerealVariedad)
      this.props.actualizarDropdownEtiquetas(this.props.cereal, this.props.cerealVariedad)
    }
  }

  render () {
    return (
      <FiltroCerealCerealVariedadYEtiquetaView
        etiquetas={this.props.etiquetas}
        submitFiltrosParaEmbarque={this.props.submitFiltrosParaEmbarque}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  etiquetas: state.filtroCerealCerealVariedadEtiquetas.etiquetas,
  // cereal: state.filtroCerealCerealVariedadEtiquetas.cereal,
  // cerealVariedad: state.filtroCerealCerealVariedadEtiquetas.cerealVariedad
  cereal: state.cereal.selectedCerealEspecie || null,
  cerealVariedad: state.cereal.selectedCerealVariedad || null
})

const mapDispatchToProps = {
  actualizarDropdownEtiquetas,
  submitFiltrosParaEmbarque
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltroCerealCerealVariedadYEtiqueta)
